import EntryForm from './entryForm';
import entryFormMaterialStyles from './entryForm.materialStyles';
import { withStyles } from '@material-ui/core';
import { compose } from '../../../../../utils/func';

export default compose(
  withStyles(entryFormMaterialStyles),
)(EntryForm);